export * from './capitalize.pipe';
export * from './plural.pipe';
export * from './round.pipe';
export * from './timing.pipe';



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@theme/pipes/index.ts